export default {"src":"/_next/static/media/Coronary_Artery_Disease.6b0d38d1.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};